<template>
  <path
    d="M1 3L6 5.5L11 3"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M1 7.5L6 10L11 7.5"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
</template>
